import React from "react";
import { useNavigate } from "react-router-dom";
import "./CourtItem.css";
import InfoIcon from "./details/infoicon.js";
import Facilities from "./details/facilities.js";
import CourtAddress from "./AddressFormatter.js";
import CourtItemCourts from "./CourtItemCourts.js";

function CourtItem({
  court,
  index,
  currentPhotoIndex, 
  handlePrevPhoto,
  handleNextPhoto,
}) {
  console.log("court.photos for court:", court.name, court.photos);

  const navigate = useNavigate();

  const formatUrl = (court) => {
    const country = court.address.country?.toLowerCase().replace(/\s+/g, "-");
    const state = court.address.state?.toLowerCase().replace(/\s+/g, "-");
    const city = court.address.city?.toLowerCase().replace(/\s+/g, "-");
    const slug = court.slug;

    let url = `/courts`;

    if (country) url += `/${country}`;
    if (state) url += `/${state}`;
    if (city) url += `/${city}`;
    if (slug) url += `/${slug}`;

    return url;
  };

  // Safe photo index access
  const photoIndex = currentPhotoIndex[index] || 0;
  
  // Safe photo URL fallback
const photoUrl = court.photos?.length > photoIndex && court.photos[photoIndex]?.url
  ? court.photos[photoIndex].url
  : "/images/futsal-ai.png"; // Make sure this is in the public folder

  const getCourtType = (courts) => {
    const types = new Set();

    courts.forEach((court) => {
      if (court.surface_type) {
        types.add(court.surface_type.trim().toLowerCase()); // Normalize
      }
    });

    const hasIndoor = Array.from(types).some((type) => type.startsWith("indoor"));
    const hasOutdoor = Array.from(types).some((type) => type.startsWith("outdoor"));
    const hasHard = Array.from(types).some((type) => type.endsWith("hard"));
    const hasSoft = Array.from(types).some((type) => type.endsWith("soft"));

    // Build result string
    if (hasIndoor && hasOutdoor) {
      if (hasHard && hasSoft) return "Indoor and Outdoor (Hard and Soft)";
      if (hasHard) return "Indoor and Outdoor (Hard)";
      if (hasSoft) return "Indoor and Outdoor (Soft)";
      return "Indoor and Outdoor";
    } else if (hasIndoor) {
      if (hasHard && hasSoft) return "Indoor (Hard and Soft)";
      if (hasHard) return "Indoor (Hard)";
      if (hasSoft) return "Indoor (Soft)";
      return "Indoor";
    } else if (hasOutdoor) {
      if (hasHard && hasSoft) return "Outdoor (Hard and Soft)";
      if (hasHard) return "Outdoor (Hard)";
      if (hasSoft) return "Outdoor (Soft)";
      return "Outdoor";
    } else {
      return "Unknown";
    }
  };

  return (
    <div className="court-item-container">
      {/* Left: Court Photo Gallery */}
      <div className="court-item-photo-gallery">
        <button onClick={() => handlePrevPhoto(index)}>◀</button>
        <img
          src={photoUrl}
          alt={court.name}
        />
        <button onClick={() => handleNextPhoto(index)}>▶</button>
      </div>

      {/* Right: Court Details */}
      <div className="court-item-info">
        {/* Court Title */}
        <div className="court-detail-info-header">
          <InfoIcon
            content={
              <div>
                <p>We strive to provide the most up to date court</p>
                <p>information at each venue. If something doesn't look</p>
                <p>right please reach out at thefutsaldirectory@gmail.com</p>
                <p>and we will put it right!</p>
              </div>
            }
          />
        </div>
        <h3
          className="court-item-title"
          onClick={() => navigate(formatUrl(court))}
          onMouseEnter={(e) => e.target.classList.add("hover")}
          onMouseLeave={(e) => e.target.classList.remove("hover")}
        >
          {court.name}
        </h3>
        {/* Venue Description */}
        <p className="court-item-description">{court.description}</p>
        <CourtAddress court={court} />
        <p
          className="court-options-text"
          data-tooltip="This shows the different court layouts available at this venue"
        >
          <strong>Court Options:</strong>
        </p>
        <CourtItemCourts courts={court.courts} />
        <p>
          <strong>Type:</strong> {getCourtType(court.courts)}
        </p>
        <Facilities court={court} />
        {/* Grouped Shared Courts */}
        {court.sharedCourts?.length > 0 && (
          <div className="court-item-shared-courts">
            <h4>Shared Courts:</h4>
            <ul>
              {court.sharedCourts.map((sharedCourt, idx) => (
                <li key={idx}>{sharedCourt}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default CourtItem;
